import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useFormikContext } from 'formik';
import { useUnlayerTemplateContext } from '@/context/UnlayerTemplateContext';

/**
 * Collects the template name before saving the current editor state as a reusable template.
 */
export const SaveTemplateDialog = () => {
	const {
		closeSaveTemplateDialog,
		isSaveTemplateDialogOpen,
		isSavingTemplate,
		saveAsTemplate,
		templateNameError,
		templateNameInput,
		updateTemplateNameInput,
	} = useUnlayerTemplateContext();
	const { values } = useFormikContext();

	return (
		<Dialog open={isSaveTemplateDialogOpen} onClose={closeSaveTemplateDialog} fullWidth maxWidth='sm'>
			<DialogTitle>Save As Template</DialogTitle>
			<DialogContent>
				<TextField
					autoFocus
					fullWidth
					label='Template Name'
					value={templateNameInput}
					onChange={(event) => updateTemplateNameInput(event.target.value)}
					error={Boolean(templateNameError)}
					helperText={templateNameError || ' '}
					sx={{ mt: 1 }}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={closeSaveTemplateDialog}>Cancel</Button>
				<Button
					variant='contained'
					onClick={() =>
						saveAsTemplate({
							subject: values.subject,
							editorDesign: values.editorDesign,
						})
					}
					disabled={isSavingTemplate}
				>
					Save
				</Button>
			</DialogActions>
		</Dialog>
	);
};
